<template>
  <ContentPage>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">{{ me.name }}</div>
    </template>

    <div class="grey lighten-3" style="height: 100%">
      <v-list class="py-0 rounded-lg">
        <menu-item v-if="userIsAdmin" :to="{ name: 'account' }" title="Business Profile" />
        
        <v-divider v-if="userIsAdmin" />

        <menu-item :to="{ name: 'profile' }" title="Your Profile" />

        <v-divider />

        <menu-item v-if="userIsAdmin" :to="{ name: 'you/users' }" title="Users" />

        <v-divider v-if="userIsAdmin" />

        <menu-item :to="{ name: 'you/legal' }" title="Legal" />

        <v-divider/>
        
        <menu-item :to="{ name: 'support' }" title="Support" />

        <v-divider/>
        
        <menu-item :to="{ name: 'you/password' }" title="Update Password" />
        
        <v-divider/>
        
        <menu-item title="Reload App" @click="refresh" />

        <v-divider/>
        
        <menu-item title="Logout" @click="logoutClick" />
      </v-list>
    </div>
  </ContentPage>
</template>

<script>
import { ContentPage, MenuItem } from '@/components/pages'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: "YouMenuView",

  components: { ContentPage, MenuItem },

  computed: {
    ...mapGetters('auth', ['me', 'userIsAdmin']),
  },

  methods: {
    ...mapActions('auth', ['loadMe']),
    
    logoutClick() {
      this.$store.dispatch('auth/logout')
      this.$router.push( { name: 'login' })
    },

    refresh() {
      window.location.reload()
    },
  },

  created() {
    this.loadMe()
  }
}
</script>